import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import DialogTitle from "../Shared/DialogTitle";
import {
  Checkbox,
  Dialog,
  FlatButton,
  RadioButton,
  RadioButtonGroup,
  TextField,
  Toggle,
} from "material-ui";
import { checkJapanese } from "../../lib";
import {
  addQuestionnaire,
  deleteQuestionnaire,
  deleteTemplate,
  updateQuestionnaire,
  updateTemplate,
} from "./actions";
import Select from 'react-select';
import Clear from "material-ui/svg-icons/content/clear";

const toggleStyle = {
  style: { width: "44px", margin: "10px 0" },
  trackSwitchedStyle: {
    backgroundColor: "#60d1bd",
    width: "64px",
  }, thumbStyle: {
    height: "26px",
    width: "26px",
  }, thumbSwitchedStyle: {
    backgroundColor: "#fff",
  }, trackStyle: {
    borderRadius: "20px",
    height: "28px",
    width: "58px",
  }, iconStyle: {
    borderRadius: "20px",
    padding: 0,
    margin: 0,
  }
}

const inputStyle = {
  border: "1px solid #657285ab",
  height: "38px",
  padding: "0 8px",
  fontSize: "13px",
  color: "#657285",
  borderRadius: 0
};

const textFieldStyle = {
  backgroundColor: "#fff",
  height: "38px",
  margin: "8px 0",
  color: "#657285",
};

const labelStyle = {
  color: "#657285",
  fontSize: "14px",
  marginTop: "8px",
};

const errorStyle = {
  fontSize: "12px",
  color: "#ff0000",
}

const selectStyle = {
  dropdownIndicator: (provided, state) => ({
    ...provided,
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
    color: "#657285"
  }),
  container: (provided, state) => ({
    ...provided,
  }),
  control: (provided) => ({
    ...provided,
    border: '1px solid rgba(101, 114, 133, 0.67) !important',
    boxShadow: 'none',
    borderRadius: 0,
  }),
  indicatorsContainer: () => {{display: 'none'}},
  menu: (provided) => ({
    ...provided,
    marginTop: 0,
    boxShadow: 'none',
    border: '1px solid rgba(101, 114, 133, 0.67)',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTop: 0,
    cursor: "pointer"
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
    backgroundColor: state.isFocused ? "#657285 !important" : "#fff !important",
    color: state.isFocused ? "#fff !important" : "#657285 !important",
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#657285"
  }),
  noOptionsMessage: (provided) => ({
    ...provided,
    fontSize: '12px'
  })
}

function AddToTemplate(props) {
  return (
    <div
      style={{
        display: "flex",
        margin: "12px 0 20px",
        justifyContent: "center",
      }}
    >
      <Checkbox
        label={<FormattedMessage id="transcriptions.addToTemplate" />}
        style={{
          width: "auto",
          backgroundColor: "#e9e9eb",
          padding: "8px 0",
        }}
        labelStyle={{
          fontSize: "14px",
          color: "#657285",
          width: "auto",
          margin: "0 25px 0 12px",
        }}
        iconStyle={{
          fill: "#657285",
        }}
        checked={props.addToTemplate}
        onCheck={props.onAddToTemplateToggle}
      />
    </div>
  );
}

function ActionButtons(props) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
      }}
    >
      {(props.isEdit && !props.reRegister) ||
        (!props.reRegister && (
          <FlatButton
            backgroundColor="#d75654"
            hoverColor="#d75654"
            label={<FormattedMessage id="emailAddressBook.delete" />}
            labelStyle={{ color: "#fff" }}
            onClick={props.handleDelete}
          />
        ))}
      {(props.isEdit && props.reRegister) ||
        (props.reRegister && (
          <FlatButton
            backgroundColor="#d75654"
            hoverColor="#d75654"
            label={<FormattedMessage id="emailAddressBook.cancel" />}
            labelStyle={{ color: "#fff" }}
            onClick={props.handleClose}
          />
        ))}
      <FlatButton
        label={<FormattedMessage id="seminarActions.clear" />}
        labelStyle={{ color: "#858585" }}
        onClick={props.clearForm}
      />
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={<FormattedMessage id="emailAddressBook.save" />}
        labelStyle={{ color: "#fff" }}
        onClick={props.handleSubmit}
        disabled={props.disableSubmitButton}
      />
    </div>
  );
}

class AddQuestionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      room: "",
      title: "",
      question: "",
      options: [],
      freeDescription: false,
      anonymous: "yes",
      choices: "single",
      addToTemplate: false,
      showAddToTemplate: true,
      editTemplate: false,
      rooms: [],
      errors: {
        room: "",
        title: "",
        question: "",
        options: "",
        hasDescriptionOrOptions: ""
      },
      disableSubmitButton: false,
      showOptions: false
    };
  }

  componentDidMount() {
    if (this.props.selectedQuestionnaire) {
      this.setQuestionnaire(this.props.selectedQuestionnaire);
    }

    if (this.props.selectedTemplate) {
      this.setTemplate(this.props.selectedTemplate);
    }

    if(this.props.selectedTemplateToFill) {
      this.setState({
        editTemplate: false,
        showAddToTemplate: false,
      });
      this.fillTemplate(this.props.selectedTemplateToFill);
    }
    this.setState({ rooms: this.props.rooms.map(r => ({ value: r.id, label: r.fvroom_name})) });
  }

  fillTemplate = (template) => {
    this.setState({
      title: template.title,
      question: template.question,
      options: template.options,
      freeDescription: template.free_description,
      anonymous: template.anonymous,
      choices: template.choices,
      showOptions: template.options.length > 0
    })
  }

  setTemplate = (template) => {
    this.setState({
      editTemplate: true,
      showAddToTemplate: false,
    });
    this.fillTemplate(template);
  };

  setQuestionnaire = (questionnaire) => {
    const roomExists = this.props.rooms && this.props.rooms.find(r => r.id === questionnaire.room_id);
    this.setState({
      room: roomExists ? {value: questionnaire.room_id, label: questionnaire.room_name }: { value: "", label: "" },
      showAddToTemplate: false,
      editTemplate: false
    });
    this.fillTemplate(questionnaire);
  };

  handleAddOption = () => {
    let options = this.state.options;
    options.push({ id: Date.now(), value: "" });
    this.setState({ options, hasOptionError: false });
    this.resetError('options');
  };

  handleOptionChange = (e, id) => {
    let options = this.state.options;
    options = options.map((option) => {
      if (option.id === id) {
        option.value = e.target.value;
      }
      return option;
    });
    this.setState({ options });
  };

  onAddToTemplateToggle = () => {
    this.setState({ addToTemplate: !this.state.addToTemplate });
  };

  checkIfFormValid = () => {
    if((this.state.showOptions && (this.state.options.length === 0 || 
      this.state.options.every(option => option.value === ""))) ||
      this.state.title === "" ||
      this.state.question === "" ||
      (!this.state.freeDescription && !this.state.showOptions)
    ){
      return false;
    } else {
      return this.state.editTemplate ? true : !(this.state.room === "")
    }
  }

  setErrors = () => {
    let errors = this.state.errors;
    errors.question = this.state.question === "";
    errors.title = this.state.title === "";
    errors.room = this.state.room === "";
    errors.options = (this.state.showOptions && this.state.options.length === 0) || 
    (this.state.showOptions && this.state.options.every(option => option.value === ""));
    errors.hasDescriptionOrOptions = (!this.state.freeDescription && !this.state.showOptions);
    this.setState({ errors, disableSubmitButton: false });
  }

  resetError = (fieldName) => {
    let errors = this.state.errors;
    errors[fieldName] = false;
    this.setState({ errors });
  }

  handleSubmit = () => {
    this.setState({ disableSubmitButton: true })
    if(!this.checkIfFormValid()) {
      this.setErrors();
      return;
    }
    const room = this.props.rooms.find((r) => r.id === this.state.room.value);
    const options = this.state.options.filter(opt => opt.value !== "");
    const data = {
      title: this.state.title,
      question: this.state.question,
      options: this.state.showOptions ? JSON.stringify(options) : JSON.stringify([]),
      free_description: this.state.freeDescription,
      choices: this.state.choices,
      anonymous: this.state.anonymous,
      add_to_template: this.state.addToTemplate,
      room_id: this.state.room.value,
      room_name: room ? room.fvroom_name : null,
      register: this.props.reRegister
    };

    if (this.state.editTemplate && this.props.selectedTemplate) {
      data.id = this.props.selectedTemplate.id;
      this.updateTemplate(data);
    } else {
      if (this.props.selectedQuestionnaire && !data.register) {
        data.id = this.props.selectedQuestionnaire.id;
        this.updateQuestionnaire(data);
      } else {
        this.addQuestionnaire(data);
      }
    }
  };

  handleDelete = () => {
    this.state.editTemplate && this.props.selectedTemplate
      ? this.deleteTemplate()
      : this.deleteQuestionnaire();
  };

  addQuestionnaire = (data) => {
    addQuestionnaire(data)
      .then((response) => {
        this.props.onSuccess();
        this.setState({ disableSubmitButton: false });
      })
      .catch((error) => {
        console.log("Error: ", error);
        this.setState({ disableSubmitButton: false });
      });
  };

  updateQuestionnaire = (data) => {
    updateQuestionnaire(data)
      .then((response) => {
        this.props.onSuccess();
        this.setState({ disableSubmitButton: false });
      })
      .catch((error) => {
        console.log("Error: ", error);
        this.setState({ disableSubmitButton: false });
      });
  };

  deleteQuestionnaire = () => {
    if (
      this.props.selectedQuestionnaire &&
      this.props.selectedQuestionnaire.id
    ) {
      let confirmation = window.confirm(
        checkJapanese()
          ? "アンケートを削除します。よろしいですか？"
          : "Are you sure you want to delete the questionnaire?"
      );
      if (confirmation) {
        deleteQuestionnaire(this.props.selectedQuestionnaire.id)
          .then((response) => {
            this.props.onSuccess();
          })
          .catch((error) => {
            this.setState({
              hasError: true,
              errorMessage: checkJapanese()
                ? "サーバでエラーが発生し、アンケートを削除できません。しばらくしてから再度お試しください "
                : "Unable to delete the qustionnaire, server error occured. please try again later.",
            });
          });
      }
    }
  };

  updateTemplate = (data) => {
    updateTemplate(data)
      .then((response) => {
        console.log("Response: ", response);
        this.props.onSuccess();
        this.setState({ disableSubmitButton: false });
      })
      .catch((error) => {
        console.log("Error: ", error);
        this.setState({ disableSubmitButton: false });
      });
  };

  deleteTemplate = () => {
    if (this.props.selectedTemplate && this.props.selectedTemplate.id) {
      let confirmation = window.confirm(
        checkJapanese()
          ? "テンプレートを削除します。よろしいですか？"
          : "Are you sure you want to delete the template?"
      );
      if (confirmation) {
        deleteTemplate(this.props.selectedTemplate.id)
          .then((res) => {
            this.props.onSuccess();
          })
          .catch((errr) => {
            console.log("Error: ", err);
            this.setState({
              hasError: true,
              errorMessage: checkJapanese()
                ? "サーバでエラーが発生し、テンプレートを削除できません。しばらくしてから再度お試しください"
                : "Unable to delete the template, server error occured. please try again later.",
            });
          });
      }
    }
  };

  clearForm = () => {
    this.setState({
      room: "",
      title: "",
      question: "",
      options: [],
      freeDescription: false,
      anonymous: "yes",
      choices: "single",
      addToTemplate: false,
    })
  }

  deleteOption = (option) => {
    let options = this.state.options;
    options = options.filter(o => o.id !== option.id);
    this.setState({ options });
  }

  render() {
    const { formatMessage } = this.props.intl;
    let placeholders = {
      title: formatMessage({ id: "questionnaire.titlePlaceholder" }),
      question: formatMessage({ id: "questionnaire.questionPlaceholder" }),
      option1: formatMessage({ id: "questionnaire.option1" }),
      option2: formatMessage({ id: "questionnaire.option2" }),
      option3: formatMessage({ id: "questionnaire.option3" }),
      addOption: formatMessage({ id: "questionnaire.addOptionPlaceholder"})
    };

    const actions = [
      <ActionButtons
        handleClose={this.props.handleClose}
        handleSubmit={this.handleSubmit}
        handleDelete={this.handleDelete}
        reRegister={this.props.reRegister}
        isEdit={this.props.isEdit}
        clearForm={this.clearForm}
        disableSubmitButton={this.state.disableSubmitButton}
      />,
    ];

    if (this.state.showAddToTemplate) {
      actions.push(
        <AddToTemplate
          addToTemplate={this.state.addToTemplate}
          onAddToTemplateToggle={this.onAddToTemplateToggle}
        />
      );
    }

    return (
      <Dialog
        modal={false}
        repositionOnUpdate={false}
        title={
          <DialogTitle
            heading={<FormattedMessage id="transcriptions.createAndEdit" />}
            handleClose={this.props.handleClose}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "550px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: "flex",
          justifyContent: "center",
          backgroundColor: "rgb(241, 241, 241)",
          padding: this.state.showAddToTemplate
            ? "10px 28px 5px"
            : "10px 28px 10px",
          flexDirection: "column",
        }}
        className="popup-modal questionnaire-popup"
        bodyClassName="popup-modal-body"
      >
        <div
          className="questionnaire-popup-body-content"
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 25px",
          }}
        >
          {!this.state.editTemplate && (
            <div style={{ display: "flex" }}>
              <div
                style={{
                  flex: "0 0 23%",
                  paddingTop: "4px",
                  fontSize: "14px",
                  color: "#657285",
                }}
              >
                <FormattedMessage id="roomList.roomName" />
              </div>

              <div style={{ flex: "1 0 auto", marginLeft: "10px" }}>
              <Select
                options={this.state.rooms}
                onChange={(value) => {
                  this.resetError('room');
                  this.setState({ room: value });
                }}
                placeholder=""
                component={{
                  IndicatorSeparator: () => null
                }}
                styles={selectStyle}
                value={this.state.room}
                noOptionsMessage={({inputValue}) => !inputValue ? noOptionsText : <FormattedMessage id="emailAddressBook.noResultFound" />} 
              />
              {this.state.errors.room && <div style={{...errorStyle, marginTop: '6px' }}><FormattedMessage id="questionnaire.roomSelectError" /></div>}
              </div>
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ ...labelStyle, fontSize: "12px" }}>
              <FormattedMessage id="questionnaire.title" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={{ ...inputStyle, fontSize: "12px" }}
              placeholder={placeholders.title}
              type="text"
              value={this.state.title}
              name="title"
              onChange={(e) => {
                this.resetError('title');
                this.setState({ title: e.target.value });
              }}
            />
            {this.state.errors.title && <div style={errorStyle}><FormattedMessage id="questionnaire.titleError" /></div>}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ ...labelStyle, fontSize: "12px" }}>
              <FormattedMessage id="questionnaire.question" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={{ ...textFieldStyle, minHeight: "100px" }}
              inputStyle={{
                ...inputStyle,
                fontSize: "13px",
                height: "100%",
              }}
              type="text"
              rows={3}
              textareaStyle={{
                color: "#657285",
              }}
              multiLine={true}
              placeholder={placeholders.question}
              value={this.state.question}
              name="question"
              onChange={(e) => {
                this.resetError('question');
                this.setState({ question: e.target.value })
              }}
            />
            {this.state.errors.question && <div style={errorStyle}><FormattedMessage id="questionnaire.questionError" /></div>}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{ ...labelStyle, fontSize: "12px" }}>
              <FormattedMessage id="questionnaire.anonymous" />
            </label>

            <div style={{ padding: '10px 0', margin: '10px 0', border: '1px solid #657285ab', backgroundColor: '#fff' }}>
              <RadioButtonGroup
                  name="Anonymous"
                  defaultSelected="yes"
                  style={{ marginLeft: "12px", minWidth: "130px", display: 'flex' }}
                  valueSelected={this.state.anonymous}
                  className="add-question-radio-button"
                  onChange={(e, value) => this.setState({ anonymous: value })}
                >
                  <RadioButton
                    value="yes"
                    label={<FormattedMessage id="questionnaire.allowed" />}
                    style={{
                      fontSize: "12px",
                      width: 'unset',
                      marginRight: '10px'
                    }}
                    labelStyle={{
                      color: "#657285",
                    }}
                    iconStyle={{
                      fill: "#657285",
                      marginRight: '5px'
                    }}
                  />
                  <RadioButton
                    value="no"
                    label={<FormattedMessage id="questionnaire.notAllowed" />}
                    style={{
                      fontSize: "12px",
                      width: 'unset',
                      minWidth: '135px'
                    }}
                    labelStyle={{
                      color: "#657285",
                    }}
                    iconStyle={{
                      fill: "#657285",
                      marginRight: '5px'
                    }}
                  />
                </RadioButtonGroup>
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{...labelStyle, fontSize: '12px' }}>
              <FormattedMessage id="questionnaire.options" />
            </label>
            <Toggle
              style={toggleStyle.style}
              toggled={this.state.showOptions}
              onToggle={(e, isToggled) => {
                this.setState({ showOptions: isToggled });
                if(this.state.options.length === 0) {
                  this.handleAddOption();
                }
              }}
              trackSwitchedStyle={toggleStyle.trackSwitchedStyle}
              thumbStyle={toggleStyle.thumbStyle}
              thumbSwitchedStyle={toggleStyle.thumbSwitchedStyle}
              size="large"
              trackStyle={toggleStyle.trackStyle}
              iconStyle={toggleStyle.iconStyle}
            />
             {this.state.showOptions && <div style={{ padding: '10px 0', margin: '0 0 10px', border: '1px solid #657285ab', backgroundColor: '#fff' }}>
              <div style={{ display: "flex", flexDirection: "column", marginTop: '5px' }}>
                <div style={{ padding: '0 16px'}}>
                  {this.state.options.map((option, index) => {
                    return (
                      <div style={{ position: 'relative' }}>
                        <TextField
                          key={option.id}
                          fullWidth={true}
                          underlineShow={false}
                          style={{ ...textFieldStyle, margin: 0 }}
                          inputStyle={{
                            ...inputStyle,
                            fontSize: "13px",
                            backgroundColor: '#f1f1f1',
                            borderBottom:
                              this.state.options.length === index + 1
                                ? "1px solid #657285ab"
                                : "0",
                          }}
                          type="text"
                          name={"option" + index}
                          value={option.value}
                          placeholder={placeholders.addOption}
                          onChange={(e) => {
                            this.handleOptionChange(e, option.id);
                          }}
                        ></TextField>
                        <Clear onClick={() => this.deleteOption(option)} style={{ position: 'absolute', right: '10px', top: '6px', color: '#657285e6', cursor: 'pointer' }} />
                      </div>
                    );
                  })}
                </div>

                {this.state.errors.options && <div style={{ fontSize: '12px', color
              : "#ff0000", marginTop: '6px', marginLeft: '16px' }}><FormattedMessage id="questionnaire.addOptions" /></div>}

                <FlatButton
                  backgroundColor="#e9e9eb"
                  hoverColor="#e9e9eb"
                  label={<FormattedMessage id="questionnaire.addNewOption" />}
                  labelStyle={{ color: "#657285" }}
                  onClick={this.handleAddOption}
                  fullWidth={false}
                  style={{
                    maxWidth: "180px",
                    width: "100%",
                    margin: "auto",
                    marginTop: "12px",
                  }}
                />

              <div style={{ display: 'flex', padding: '16px 16px 0' }}>
                <label
                  className="questionnaire-select-label"
                  style={{ fontSize: "12px", marginTop: "5px", color: "#657285" }}
                >
                  <FormattedMessage id="questionnaire.select" />
                </label>
                <RadioButtonGroup
                  name="Choices"
                  defaultSelected="single"
                  style={{
                    marginLeft: "12px",
                    minWidth: "165px",
                    color: "#657285",
                    display: 'flex'
                  }}
                  valueSelected={this.state.choices}
                  className="add-question-radio-button no-flex"
                  onChange={(e, value) => this.setState({ choices: value })}
                >
                  <RadioButton
                    value="single"
                    label={<FormattedMessage id="questionnaire.one" />}
                    style={{
                      marginBottom: "8px",
                      fontSize: "12px",
                      color: "#657285",
                      minWidth: '140px'
                    }}
                    labelStyle={{
                      color: "#657285",
                    }}
                    iconStyle={{
                      fill: "#657285",
                      marginRight: '5px'
                    }}
                  />
                  <RadioButton
                    value="multiple"
                    label={<FormattedMessage id="questionnaire.multiple" />}
                    style={{
                      marginBottom: "8px",
                      fontSize: "12px",
                      color: "#657285",
                      minWidth: '140px'
                    }}
                    labelStyle={{
                      color: "#657285",
                    }}
                    iconStyle={{
                      fill: "#657285",
                      marginRight: '5px'
                    }}
                  />
                </RadioButtonGroup>
              </div>
              </div>
            </div>}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={{...labelStyle, fontSize: '12px' }}>
              <FormattedMessage id="questionnaire.freeDescription" />
            </label>
            <Toggle
              style={toggleStyle.style}
              toggled={this.state.freeDescription}
              onToggle={(e, isToggled) => {
                this.setState({ freeDescription: isToggled });
              }}
              trackSwitchedStyle={toggleStyle.trackSwitchedStyle}
              thumbStyle={toggleStyle.thumbStyle}
              thumbSwitchedStyle={toggleStyle.thumbSwitchedStyle}
              size="large"
              trackStyle={toggleStyle.trackStyle}
              iconStyle={toggleStyle.iconStyle}
            />
          </div>

          {this.state.errors.hasDescriptionOrOptions && 
            <div style={{ fontSize: '12px', color: "#ff0000", marginTop: '6px' }}>
              <FormattedMessage id="questionnaire.selectDescriptionOrOptionError" />
            </div>
          }
        </div>
      </Dialog>
    );
  }
}

export default injectIntl(AddQuestionnaire);



// WEBPACK FOOTER //
// src/components/Questionnaire/AddQuestionnaire.js